<template>
  <v-tooltip
    top
    :disabled="hint() === ''"
    color="white"
  >
    <template v-slot:activator="{ on }">
      <v-chip
        small
        outlined
        pill
        :color="color()"
        v-on="on"
      >
        <v-icon
          left
          small
        >
          {{ icon() }}
        </v-icon>

        {{ text() }}
      </v-chip>
    </template>

    <span
      class="black--text text-center"
      v-html="hint()"
    />
  </v-tooltip>
</template>
<script>
import { get, isEmpty } from 'lodash'
import { formatMoney } from "../../services/util.service"

export default {
  props: {
    payment: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {}
  },
  methods: {
    getCharge() {
      return get(this.payment, 'charges.data[0]', {})
    },
    isFullRefund() {
      const charge = this.getCharge()
      const amount = get(charge, 'amount', 0)

      return this.hasRefund() && amount === this.amountRefunded()
    },
    hasRefund() {
      return this.amountRefunded() > 0
    },
    amountRefunded() {
      const charge = this.getCharge()
      return get(charge, 'amount_refunded', 0)
    },
    getStatusConfig() {
      if (!isEmpty(this.payment.last_payment_error)) {
        const { decline_code, message } = this.payment.last_payment_error

        return {
          text: 'Failed',
          hint: `<pre>${decline_code}</pre> ${message}`,
          color: 'error',
          icon: 'close'
        }
      }

      // requires_payment_method, requires_confirmation, requires_action, processing, requires_capture, canceled, or succeeded
      const statusConfigs = {
        // Most errors will fall under requires_payment_method, including Insufficient Amount
        requires_payment_method: {
          text: 'Incomplete',
          hint: '',
          color: '',
          icon: 'access_time'
        },
        requires_confirmation: {
          text: 'Unconfirmed',
          hint: 'Payment requires confirmation',
          color: '',
          icon: ''
        },
        requires_action: {
          text: 'Action Required',
          hint: 'An additional action is required to complete this payment; Customer may be required to authenticate using 3D Secure',
          color: 'warning',
          icon: ''
        },
        processing: {
          text: 'Processing',
          hint: '',
          color: '',
          icon: 'access_time'
        },
        requires_capture: {
          text: 'Uncaptured',
          hint: '',
          color: '',
          icon: 'access_time'
        },
        canceled: {
          text: 'Cancelled',
          hint: `Cancellation reason: <code>${this.payment.cancellation_reason}</code>`,
          color: '',
          icon: 'close'
        },
        succeeded: {
          text: 'Succeeded',
          hint: '',
          color: 'success',
          icon: 'done'
        },
      }

      // Refunds have to be handled as a special case
      const refundAmountText = formatMoney({
        amount: this.amountRefunded(),
        currency: this.getCharge().currency
      })
      const refundMap = {
        partial: {
          text: 'Partial refund',
          hint: `${refundAmountText} was refunded`,
          color: 'info',
          icon: 'info'
        },
        full: {
          text: 'Refunded',
          hint: '',
          color: 'info',
          icon: 'undo'
        }
      }

      // Fallback configuration
      const unknownConfig = {
        text: 'Unknown',
        hint: '',
        color: '',
        icon: 'done'
      }

      let statusConfig = null
      const { status } = this.payment

      if (status === 'succeeded' && this.hasRefund()) {
        // If there is a refund, its ether a full refund, or a partial refund
        statusConfig = this.isFullRefund()
          ? refundMap.full
          : refundMap.partial
      } else {
        statusConfig = status in statusConfigs
          ? statusConfigs[ status ]
          : unknownConfig
      }


      return statusConfig
    },
    text() {
      const config = this.getStatusConfig()
      const { text } = config

      return text
    },
    hint() {
      const config = this.getStatusConfig()
      const { hint } = config

      return hint
    },
    icon() {
      const config = this.getStatusConfig()
      const { icon } = config

      return icon
    },
    color() {
      const config = this.getStatusConfig()
      const { color } = config

      return color
    },
  },
}
</script>
